export const getMeta = (state) => {
  return state?.getMeta()[`${state.machine.id}.${state.value}`];
};

export const addQueryString = (url, queryParams) => {
  const hasQueryParams = queryParams && Object.values(queryParams).length;
  if (!hasQueryParams) return url;

  const querryParamsString = new URLSearchParams(queryParams).toString();

  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}${querryParamsString}`;
};

export const addHash = (url, hash) => {
  if (!hash) return url;

  if (hash.startsWith('#')) {
    return `${url}${hash}`;
  }

  return `${url}#${hash}`;
};
